"use client"

import { useQuery } from "@tanstack/react-query"
import {
  getSystemNotificationSettingsAction,
  type SystemNotificationSettingsView,
} from "@/server-actions/system-notifications"

export const systemNotificationsQueryKey = ["notifications", "system-events"] as const

export function useSystemNotificationSettingsQuery() {
  return useQuery<SystemNotificationSettingsView>({
    queryKey: systemNotificationsQueryKey,
    queryFn: async () => {
      const result = await getSystemNotificationSettingsAction({})
      if ("status" in result) throw new Error(result.errorMessage)
      return result
    },
  })
}
